<template>
  
</template>

<script>
export default {
    data() {
        this.$router.replace('/cart')
        return {
            
        }
    },
}
</script>

<style>

</style>